import Image from "next/image";

import Logo from "../assets/CM-Logo-Colour.png";
import PartModal from "../PartModal";
import PartPendingActionWrapper from "../PartPendingActionWrapper";
import { useAuth } from "@/lib/useAuth";

import styles from "./ModalSignin.module.scss";

const ModalSignIn = () => {
  const auth = useAuth();

  if (auth.isLoading) return null;
  // TODO status === 'authenticated';
  // TODO status === 'unauthenticated';

  return (
    <PartModal noHeader noCloseButton showed={!auth.isAuthenticated}>
      <div className={styles.logoWrapper}>
        <Image
          src={Logo.src} // Make sure to add your logo in this path
          alt="Company Logo"
          width={138}
          height={72}
          priority
          className={styles.logo}
        />
      </div>
      <div className={styles.signInButtonContainer}>
        <PartPendingActionWrapper onClick={auth.signIn} block>
          <button
            className={styles.cognitoButton}
            data-test-element-type="button"
            data-test-action-type="do-login"
          >
            Sign in with Cognito
          </button>
        </PartPendingActionWrapper>
      </div>
    </PartModal>
  );
};

export default ModalSignIn;
